<template>
    <div class="card b-normal card-article mb-3" :class="{
        'h-100': h100,
    }" itemscope itemtype="http://schema.org/Article">
        <div class="filtered" v-if="isFilter" @click="showR18()">
            <span class="badge badge-danger">R18作品</span>
        </div>
        <div class="bg-blur">
            <img :src="article.eyecatch" v-if="article.eyecatch" itemprop="image" class="bg-placeholder-img card-img-top cover">
            <img v-lazy="cover()" itemprop="image" v-else class="bg-placeholder-img card-img-top cover" />
            <div class="p-4">
                <h5 class="card-title font-weight-bold">
                    <a :href="article.url" class="black stretched-link" target="_blank" itemprop="url" v-if="article.url">
                        {{article.title}}
                        <i class="fas fa-external-link-alt"></i>
                    </a>
                    <router-link :to="'/author/article/' + article.id" class="black stretched-link" itemprop="url" v-else>
                        {{article.title}}
                    </router-link>
                    <span class="badge" :class="['badge-' + article.rating.color]" v-if="article.rating">{{article.rating.rating_name}}</span>
                </h5>
                <div class="text-muted preface" v-if="showPreface">
                    {{article.preface}}
                </div>
                <div class="text-right small" v-if="showPreface" itemprop="dateModified">
                    {{$filters.dateFormat(article.publish_at , 'YYYY年MM月DD日')}}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cover {
    object-fit: cover;
    max-height: 190px;
    min-height: 190px;
    width: 100%;
}
.article {
    max-height: 250px;
    overflow: hidden;
}
.badge-light {
    padding: .3rem .7rem;
}
.badge {
    font-size: .7rem;
}
.card-article {
    border: 0;
    box-shadow: none;
    overflow: hidden;
    .card-title {
        font-size: 1rem;
    }
}
.preface {
    display: -webkit-box;
    max-height: 60px;
    font-size: .7rem;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: .7rem
}
.tag-list {
    li {
        font-size: .7rem;
    }
}
</style>

<script>
export default {
    props: {
        article: {
            required: true,
        },
        showPreface: {
            default: true,
        },
        h100: {
            default: true,
        }
    },
    methods: {
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
        showR18() {
            $("#r18-modal").modal();
        },
    },
    computed: {
        isFilter() {
            if (this.article?.rating?.rating_level >= 2 && !this.$store.state.user && !this.$store.state.r18) {
                return true;
            }
            return false;
        },
    },
}
</script>